import MaticLogoPinkSvg from '../../../assets/img/icons/matic-logo-pink.svg?react';
import MaticLogoSvg from '../../../assets/img/icons/matic-logo-simple.svg?react';
import AddIcon from '../../../assets/new_icons/add.svg?react';
import Add2Icon from '../../../assets/new_icons/add_2.svg?react';
import AncientGateLineIcon from '../../../assets/new_icons/ancient-gate-line.svg?react';
import AppsIcon from '../../../assets/new_icons/apps.svg?react';
import ArchiveIcon from '../../../assets/new_icons/archive.svg?react';
import ArrowDownIcon from '../../../assets/new_icons/arrow-down.svg?react';
import ArrowDown2Icon from '../../../assets/new_icons/arrow-down_2.svg?react';
import ArrowLeftIcon from '../../../assets/new_icons/arrow-left.svg?react';
import ArrowLeft2Icon from '../../../assets/new_icons/arrow-left_2.svg?react';
import ArrowRightIcon from '../../../assets/new_icons/arrow-right.svg?react';
import ArrowRight2Icon from '../../../assets/new_icons/arrow-right_2.svg?react';
import ArrowUpIcon from '../../../assets/new_icons/arrow-up.svg?react';
import ArrowUp2Icon from '../../../assets/new_icons/arrow-up_2.svg?react';
import AttachmentIcon from '../../../assets/new_icons/attachment.svg?react';
import AudioIcon from '../../../assets/new_icons/audio.svg?react';
import BoatIcon from '../../../assets/new_icons/boat.svg?react';
import BriefcaseIcon from '../../../assets/new_icons/briefcase.svg?react';
import BuildingsIcon from '../../../assets/new_icons/buildings.svg?react';
import BundleIcon from '../../../assets/new_icons/bundle.svg?react';
import CalendarIcon from '../../../assets/new_icons/calendar.svg?react';
import NonAdmittedCarIcon from '../../../assets/new_icons/car-nonadmitted.svg?react';
import CarIcon from '../../../assets/new_icons/car.svg?react';
import CatchUpIcon from '../../../assets/new_icons/catchup.svg?react';
import ChannelsIcon from '../../../assets/new_icons/channels.svg?react';
import ChartBarIcon from '../../../assets/new_icons/chart-bar.svg?react';
import ChatSmileIcon from '../../../assets/new_icons/chat-smile.svg?react';
import ChatIcon from '../../../assets/new_icons/chat.svg?react';
import CheckCircleIcon from '../../../assets/new_icons/check-circle.svg?react';
import CheckSquareIcon from '../../../assets/new_icons/check-square.svg?react';
import CheckIcon from '../../../assets/new_icons/check.svg?react';
import ChevronLeftDouble from '../../../assets/new_icons/chevron-left-double.svg?react';
import ChevronLeft from '../../../assets/new_icons/chevron-left.svg?react';
import ChevronRightDouble from '../../../assets/new_icons/chevron-right-double.svg?react';
import ChevronRight from '../../../assets/new_icons/chevron-right.svg?react';
import CircleIcon from '../../../assets/new_icons/circle.svg?react';
import ClearOutlineIcon from '../../../assets/new_icons/clear-outline.svg?react';
import ClearIcon from '../../../assets/new_icons/clear.svg?react';
import ClockIcon from '../../../assets/new_icons/clock.svg?react';
import ClockwiseClockIcon from '../../../assets/new_icons/clockwise-clock.svg?react';
import CloseIcon from '../../../assets/new_icons/close.svg?react';
import CogIcon from '../../../assets/new_icons/cog.svg?react';
import ColumnsIcon from '../../../assets/new_icons/columns.svg?react';
import CompassesIcon from '../../../assets/new_icons/compasses.svg?react';
import ContactCalendarIcon from '../../../assets/new_icons/contact-calendar.svg?react';
import ContextIcon from '../../../assets/new_icons/context.svg?react';
import CopyIcon from '../../../assets/new_icons/copy.svg?react';
import CrossOctagonIcon from '../../../assets/new_icons/cross-octagon.svg?react';
import DeleteIcon from '../../../assets/new_icons/delete.svg?react';
import DesktopIcon from '../../../assets/new_icons/desktop.svg?react';
import DiscountIcon from '../../../assets/new_icons/discount.svg?react';
import DocumentWithTickIcon from '../../../assets/new_icons/document-with-tick.svg?react';
import DocumentIcon from '../../../assets/new_icons/document.svg?react';
import DollarIcon from '../../../assets/new_icons/dollar.svg?react';
import DownloadIcon from '../../../assets/new_icons/download.svg?react';
import EarthquakeIcon from '../../../assets/new_icons/earthquake.svg?react';
import EditIcon from '../../../assets/new_icons/edit.svg?react';
import EditOutlineIcon from '../../../assets/new_icons/edit_outline.svg?react';
import EmailIcon from '../../../assets/new_icons/email.svg?react';
import ErrorIcon from '../../../assets/new_icons/error.svg?react';
import ESignIcon from '../../../assets/new_icons/esign.svg?react';
import EyeIcon from '../../../assets/new_icons/eye.svg?react';
import FilterIcon from '../../../assets/new_icons/filter.svg?react';
import Filter2Icon from '../../../assets/new_icons/filter_2.svg?react';
import FireIcon from '../../../assets/new_icons/fire.svg?react';
import FlagIcon from '../../../assets/new_icons/flag.svg?react';
import FlashIcon from '../../../assets/new_icons/flash.svg?react';
import FloodIcon from '../../../assets/new_icons/flood.svg?react';
import FullscreenIcon from '../../../assets/new_icons/fullscreen.svg?react';
import GroupIcon from '../../../assets/new_icons/group.svg?react';
import HammerLineIcon from '../../../assets/new_icons/hammer-line.svg?react';
import HelpIcon from '../../../assets/new_icons/help.svg?react';
import HistoryIcon from '../../../assets/new_icons/history.svg?react';
import HomeLineIcon from '../../../assets/new_icons/home-line.svg?react';
import NonAdmittedHomeIcon from '../../../assets/new_icons/home-nonadmitted.svg?react';
import PrimaryHomeIcon from '../../../assets/new_icons/home-primary.svg?react';
import SecondaryHomeIcon from '../../../assets/new_icons/home-secondary.svg?react';
import HomeIcon from '../../../assets/new_icons/home.svg?react';
import HotIcon from '../../../assets/new_icons/hot.svg?react';
import HourglassIcon from '../../../assets/new_icons/hourglass.svg?react';
import InboundCallIcon from '../../../assets/new_icons/inbound_call.svg?react';
import InboundEmailIcon from '../../../assets/new_icons/inbound_email.svg?react';
import InboundSMSIcon from '../../../assets/new_icons/inbound_sms.svg?react';
import InfoOutlinedIcon from '../../../assets/new_icons/info-outlined.svg?react';
import InfoIcon from '../../../assets/new_icons/info.svg?react';
import InvoiceIcon from '../../../assets/new_icons/invoice.svg?react';
import JewelryIcon from '../../../assets/new_icons/jewelry.svg?react';
import KeyIcon from '../../../assets/new_icons/key.svg?react';
import LeadingIcon from '../../../assets/new_icons/leading.svg?react';
import LifeIcon from '../../../assets/new_icons/life.svg?react';
import LightbulbIcon from '../../../assets/new_icons/lightbulb.svg?react';
import LinkSharpIcon from '../../../assets/new_icons/link_sharp.svg?react';
import MailIcon from '../../../assets/new_icons/mail.svg?react';
import MapIcon from '../../../assets/new_icons/map.svg?react';
import MaticLogoBroken from '../../../assets/new_icons/matic_logo_broken.svg?react';
import MoreIcon from '../../../assets/new_icons/more.svg?react';
import MotorbikeIcon from '../../../assets/new_icons/motorbike.svg?react';
import NoteIcon from '../../../assets/new_icons/note.svg?react';
import OpenInNewArrowlessIcon from '../../../assets/new_icons/open-in-new-arrowless.svg?react';
import OpenInNewIcon from '../../../assets/new_icons/open-in-new.svg?react';
import OperationsIcon from '../../../assets/new_icons/operations.svg?react';
import OutboundCallIcon from '../../../assets/new_icons/outbound_call.svg?react';
import OutboundEmailIcon from '../../../assets/new_icons/outbound_email.svg?react';
import OutboundSMSIcon from '../../../assets/new_icons/outbound_sms.svg?react';
import PaintBrushLineIcon from '../../../assets/new_icons/paint-brush-line.svg?react';
import PartialSuccessIcon from '../../../assets/new_icons/partial-success.svg?react';
import PartnerIcon from '../../../assets/new_icons/partner.svg?react';
import PencilIcon from '../../../assets/new_icons/pencil.svg?react';
import PercentageIcon from '../../../assets/new_icons/percentage.svg?react';
import PetIcon from '../../../assets/new_icons/pet.svg?react';
import PhoneMissedIcon from '../../../assets/new_icons/phone-missed.svg?react';
import PhoneIcon from '../../../assets/new_icons/phone.svg?react';
import PinIcon from '../../../assets/new_icons/pin.svg?react';
import PictureInPictureIcon from '../../../assets/new_icons/pip.svg?react';
import PuzzlePieceIcon from '../../../assets/new_icons/puzzle-piece.svg?react';
import QuestionMarkHollowIcon from '../../../assets/new_icons/question-mark-hollow.svg?react';
import QuestionMarkIcon from '../../../assets/new_icons/question-mark.svg?react';
import QuoteIcon from '../../../assets/new_icons/quote.svg?react';
import RefreshCwIcon from '../../../assets/new_icons/refresh-cw.svg?react';
import RefreshIcon from '../../../assets/new_icons/refresh.svg?react';
import RenewIcon from '../../../assets/new_icons/renew.svg?react';
import RobotIcon from '../../../assets/new_icons/robot.svg?react';
import RVIcon from '../../../assets/new_icons/rv.svg?react';
import SafetyIcon from '../../../assets/new_icons/safety.svg?react';
import ScalesIcon from '../../../assets/new_icons/scales.svg?react';
import SearchIcon from '../../../assets/new_icons/search.svg?react';
import SecurePaymentIcon from '../../../assets/new_icons/secure-payment.svg?react';
import SettingsIcon from '../../../assets/new_icons/settings.svg?react';
import ShieldCheckIcon from '../../../assets/new_icons/shield-check.svg?react';
import ShieldCrossIcon from '../../../assets/new_icons/shield-cross.svg?react';
import ShieldWarningIcon from '../../../assets/new_icons/shield-warning.svg?react';
import ShieldIcon from '../../../assets/new_icons/shield.svg?react';
import SnowIcon from '../../../assets/new_icons/snow.svg?react';
import SortIcon from '../../../assets/new_icons/sort.svg?react';
import SortingArrowsIcon from '../../../assets/new_icons/sorting-arrows.svg?react';
import Sparkles1 from '../../../assets/new_icons/sparkles-1.svg?react';
import Sparkles2 from '../../../assets/new_icons/sparkles-2.svg?react';
import Sparkles3 from '../../../assets/new_icons/sparkles-3.svg?react';
import Sparkles4 from '../../../assets/new_icons/sparkles-4.svg?react';
import SpinnerIcon from '../../../assets/new_icons/spinner.svg?react';
import StarIcon from '../../../assets/new_icons/star.svg?react';
import SwapIcon from '../../../assets/new_icons/swap.svg?react';
import TaskIcon from '../../../assets/new_icons/task.svg?react';
import TempHotLineIcon from '../../../assets/new_icons/temp-hot-line.svg?react';
import TickIcon from '../../../assets/new_icons/tick.svg?react';
import TodoIcon from '../../../assets/new_icons/todo.svg?react';
import TransactionIcon from '../../../assets/new_icons/transaction.svg?react';
import TransferIcon from '../../../assets/new_icons/transfer.svg?react';
import TrendingUpIcon from '../../../assets/new_icons/trending_up.svg?react';
import TurnIcon from '../../../assets/new_icons/turn.svg?react';
import UmbrellaIcon from '../../../assets/new_icons/umbrella.svg?react';
import UploadIcon from '../../../assets/new_icons/upload.svg?react';
import UserAddIcon from '../../../assets/new_icons/user-add.svg?react';
import UserMinusIcon from '../../../assets/new_icons/user-minus.svg?react';
import UserVoiceIcon from '../../../assets/new_icons/user-voice.svg?react';
import UserIcon from '../../../assets/new_icons/user.svg?react';
import UsersIcon from '../../../assets/new_icons/users.svg?react';
import VisibilityOffIcon from '../../../assets/new_icons/visibility-off.svg?react';
import VisibilityIcon from '../../../assets/new_icons/visibility.svg?react';
import VoicemailIcon from '../../../assets/new_icons/voicemail.svg?react';
import WarningIcon from '../../../assets/new_icons/warning.svg?react';
import ZoomInIcon from '../../../assets/new_icons/zoom-in.svg?react';
import ZoomOutIcon from '../../../assets/new_icons/zoom-out.svg?react';
import withSpookyLogo from '../../SpookyMode/withSpookyLogo';

const MaticLogo = withSpookyLogo(MaticLogoSvg);
const MaticLogoPink = withSpookyLogo(MaticLogoPinkSvg);

export {
  Add2Icon,
  AddIcon,
  AncientGateLineIcon,
  AppsIcon,
  ArchiveIcon,
  ArrowDown2Icon,
  ArrowDownIcon,
  ArrowLeft2Icon,
  ArrowLeftIcon,
  ArrowRight2Icon,
  ArrowRightIcon,
  ArrowUp2Icon,
  ArrowUpIcon,
  AttachmentIcon,
  AudioIcon,
  BoatIcon,
  BriefcaseIcon,
  BuildingsIcon,
  BundleIcon,
  CalendarIcon,
  CarIcon,
  CatchUpIcon,
  ChannelsIcon,
  ChartBarIcon,
  ChatIcon,
  ChatSmileIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronLeft,
  ChevronLeftDouble,
  ChevronRight,
  ChevronRightDouble,
  CircleIcon,
  ClearIcon,
  ClearOutlineIcon,
  ClockIcon,
  ClockwiseClockIcon,
  CloseIcon,
  CogIcon,
  ColumnsIcon,
  CompassesIcon,
  ContactCalendarIcon,
  ContextIcon,
  CopyIcon,
  CrossOctagonIcon,
  DeleteIcon,
  DesktopIcon,
  DiscountIcon,
  DocumentIcon,
  DocumentWithTickIcon,
  DollarIcon,
  DownloadIcon,
  EarthquakeIcon,
  EditIcon,
  EditOutlineIcon,
  EmailIcon,
  ErrorIcon,
  ESignIcon,
  EyeIcon,
  Filter2Icon,
  FilterIcon,
  FireIcon,
  FlagIcon,
  FlashIcon,
  FloodIcon,
  FullscreenIcon,
  GroupIcon,
  HammerLineIcon,
  HelpIcon,
  HistoryIcon,
  HomeIcon,
  HomeLineIcon,
  HotIcon,
  HourglassIcon,
  InboundCallIcon,
  InboundEmailIcon,
  InboundSMSIcon,
  InfoIcon,
  InfoOutlinedIcon,
  InvoiceIcon,
  JewelryIcon,
  KeyIcon,
  LeadingIcon,
  LifeIcon,
  LightbulbIcon,
  LinkSharpIcon,
  MailIcon,
  MapIcon,
  MaticLogo,
  MaticLogoBroken,
  MaticLogoPink,
  MoreIcon,
  MotorbikeIcon,
  NonAdmittedCarIcon,
  NonAdmittedHomeIcon,
  NoteIcon,
  OpenInNewArrowlessIcon,
  OpenInNewIcon,
  OperationsIcon,
  OutboundCallIcon,
  OutboundEmailIcon,
  OutboundSMSIcon,
  PaintBrushLineIcon,
  PartialSuccessIcon,
  PartnerIcon,
  PencilIcon,
  PercentageIcon,
  PetIcon,
  PhoneIcon,
  PhoneMissedIcon,
  PictureInPictureIcon,
  PinIcon,
  PrimaryHomeIcon,
  PuzzlePieceIcon,
  QuestionMarkHollowIcon,
  QuestionMarkIcon,
  QuoteIcon,
  RefreshCwIcon,
  RefreshIcon,
  RenewIcon,
  RobotIcon,
  RVIcon,
  SafetyIcon,
  ScalesIcon,
  SearchIcon,
  SecondaryHomeIcon,
  SecurePaymentIcon,
  SettingsIcon,
  ShieldCheckIcon,
  ShieldCrossIcon,
  ShieldIcon,
  ShieldWarningIcon,
  SnowIcon,
  SortIcon,
  SortingArrowsIcon,
  Sparkles1,
  Sparkles2,
  Sparkles3,
  Sparkles4,
  SpinnerIcon,
  StarIcon,
  SwapIcon,
  TaskIcon,
  TempHotLineIcon,
  TickIcon,
  TodoIcon,
  TransactionIcon,
  TransferIcon,
  TrendingUpIcon,
  TurnIcon,
  UmbrellaIcon,
  UploadIcon,
  UserAddIcon,
  UserIcon,
  UserMinusIcon,
  UsersIcon,
  UserVoiceIcon,
  VisibilityIcon,
  VisibilityOffIcon,
  VoicemailIcon,
  WarningIcon,
  ZoomInIcon,
  ZoomOutIcon
};
